<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <template >
        <v-toolbar flat>  
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-filter</v-icon>Document Field Collection Solr</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-flex lg3>
              <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
            </v-flex>
            <v-dialog v-model="dialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }" >
                <v-btn outlined v-show=insertact  rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
                  Add New Document Field
                  <v-icon class="ml-2">mdi-plus</v-icon>
                </v-btn>
              </template> 
              <v-card>
                <v-card-title>
                  <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
                </v-card-title>
                <v-card-text style="height: 500px;" class="overflow-card">
                  <v-container>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field 
                          prepend-inner-icon="mdi-cube" 
                          outlined dense 
                          v-model="name_collection" 
                          label="Name Collection">
                        </v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field 
                          prepend-inner-icon="mdi-cloud" 
                          outlined dense 
                          v-model="colection_version" 
                          label="Collection Version">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          prepend-inner-icon="mdi-cube-scan"
                          outlined
                          dense
                          v-model="description"
                          label="Description"
                          rows="3"
                          auto-grow
                        ></v-textarea>

                      </v-col>
                      
                      <v-col cols="6" sm="6" md="6">
                        <v-textarea 
                          prepend-inner-icon="mdi-cube-scan" 
                          outlined dense 
                          v-model="before" 
                          label="Field Before">
                        </v-textarea>
                      </v-col>
                      
                      <v-col cols="6" sm="6" md="6">
                        <v-textarea 
                          prepend-inner-icon="mdi-cube-scan" 
                          outlined dense 
                          v-model="after" 
                          label="Field After">
                        </v-textarea>
                      </v-col>




                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-3">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" width="330px"> 
              <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
                <v-avatar class="color-avatar3 my-4" size="62">
                  <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                </v-avatar>
                <div class="text-center text-h6 align-center justify-center font-weight-medium">
                  Confirm Deletion
                </div>
                <v-card-text class="align-center justify-center mt-2">
                  Are you sure you want to permanently delete this item?
                </v-card-text>
                <v-divider class="mt-4" style=""></v-divider>
                <v-card-actions class="align-center justify-center">
                  <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                    OK
                  </v-btn>
                  <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            
            <!-- dialog parm setting  -->
             
        </v-toolbar>
      </template>
      <v-data-table 
      :headers="headers"
      :items="dataDocument"
      :search="search"
      sort-by="paramid"
      class="ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >

        <template v-slot:[`item.beforejs`]="{ item }">
          {{  JSON.stringify(JSON.parse(item.BEFORE), null, 2) }}
        </template>
        <template v-slot:[`item.Afterjs`]="{ item }">
          {{  JSON.stringify(JSON.parse(item.AFTER), null, 2) }}
        </template>
        
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon v-show=updateact  small class="mr-2" @click="editItem(item.SEQ_ID,item.NAME_COLLECTION,item.BEFORE,item.AFTER,item.DESCRIPTION,item.VERSION)">
            mdi-pencil
          </v-icon>
          <v-icon v-show=deleteact  @click="deleteItem(item.SEQ_ID)" small>
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
      </v-data-table>
    <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios";
import '@fortawesome/fontawesome-free/css/all.css';
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",

      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,
      dialog: false,
      dialogDelete: false,
      showiconclass: false,
      
      dialogparmsetting: false,
      
      page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Document Field Report',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
      ],
      search:'',
      headers: [
        { text: 'Name Colection', value: 'NAME_COLLECTION' },
        // { text: 'Before', value: 'BEFORE' },
        { text: 'Before', value: 'beforejs', sortable: false , width: '120px'  },
        { text: 'After', value: 'Afterjs', sortable: false , width: '120px'  },
        // { text: 'After', value: 'AFTER' },
        { text: 'Description', value: 'DESCRIPTION' },
        { text: 'Version', value: 'VERSION' },
        { text: 'Actions', value: 'actions', sortable: false },
      ], 
       
      dataDocument: [],
      id_dataDocument:'',
      dataDocument_id_edit:'',
      name_collection:'',
      colection_version:'',
      description:'',
      before:'',
      after:'',
      
      editedIndex: -1,
      inputItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add Data Document' : 'Update Data Document'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      
      initialize () {
        this.tableLoading = true;
        axios.get("document-variables-solr",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            
          const data_dec = decryptionData(response.data.token);
          this.dataDocument = data_dec.data;
            // auth action  
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }   
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
          })
          .catch((e) => {
              switch (e.response.status) {
                  case 404:
                        // this.$refs.alert.error_login(404);
                      break;
                  case 403:
                        // this.$refs.alert.error_login(403);
                      break;
                  default:
                      console.log('some other error');  // end up here all the time
                      break;
              }
          this.errors=e.response.data.msg;
        });
        
      },
      deleteItem (item) {
        
        this.id_dataDocument = item
        this.editedIndex = this.dataDocument.indexOf(item)
        this.inputItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.dataDocument.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "/document-variables-solr/delete",
          data: {
            id: this.id_dataDocument
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          this.initialize();
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closeDelete()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.closeDelete()
              } 
        })
        .catch(function (error) {
          console.log(error);
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed';
          this.btnload = false
          this.closeDelete()
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.id_dataDocument = '';
        })
      },
      editItem (seq_id,name_collection,before,after,description,version) {
        this.editedIndex = 1
        this.inputItem = Object.assign({}, seq_id)
        this.dialog = true
            this.id_dataDocument = seq_id;
            this.name_collection = name_collection;
            this.before = JSON.stringify(JSON.parse(before), null, 2) ;
            this.after = JSON.stringify(JSON.parse(after), null, 2) ;
            // this.after = after;
            this.description = description;
            this.colection_version = version;

      },
      save () {
        this.btnload = true
        if (this.editedIndex > -1) {
          axios.put("/document-variables-solr/update", 
            {
                name_collection: this.name_collection,
                description:  this.description,
                field_before:  this.before,
                field_after:  this.after,
                version:  this.colection_version,
                seq_id:this.id_dataDocument,
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            this.initialize();
              this.$router.push('/DocumentVariablesSolr');
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      case 400:
                            this.alertFailed = true;
                            this.alert_err_attention =  e.response.msg;
                            this.btnload = false
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                }
            this.errors=e.response.data.msg;
          });
          Object.assign(this.dataDocument[this.editedIndex], this.inputItem)

        } else {
          axios.post("/document-variables-solr/insert", 
            {
                name_collection: this.name_collection,
                description:  this.description,
                version:  this.colection_version,
                field_before:  this.before,
                field_after:  this.after,
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            this.initialize();
              this.$router.push('/DocumentVariablesSolr');
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                  case 400:
                        this.alertFailed = true;
                        this.alert_err_attention =  e.response.data.msg;
                        this.btnload = false
                      break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
            this.errors=e.response.data.msg;
          });
          
        }
      },
      close () {
        this.showiconclass  = false
        this.dialog = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.id_dataDocument = '';
            this.name_collection = '';
            this.before = '';
            this.after = '';
            this.description = '';
            this.colection_version = '';

        })
      },
      
      
      
      
    },
  }
</script> 

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>
